package org.mkui.component.button

import com.macrofocus.common.command.Command
import com.macrofocus.common.properties.MutableProperty
import mui.material.Button
import mui.material.ButtonProps
import mui.material.Size
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC

actual class CPButton actual constructor(
    command: MutableProperty<Command?>,
    text: MutableProperty<String>
) : CPComponent {
    actual var command by command
    actual var text: String by text

    override val nativeComponent: FC<*> = FC<ButtonProps> { props ->
        val (getText, setText) = useProperty(text)

        Button {
            size = Size.small
            onClick = {
                command.value?.execute()
            }

            +getText
        }
    }

    actual fun setVisible(visible: Boolean) {
    }
}